export enum FirstLanguage {
	fi,
	sv,
	other
};

export type FirstLanguageKeys = keyof typeof FirstLanguage;